import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import { CBadge } from '@coreui/react'
import { useTranslation } from 'react-i18next'

function BadgeComponent({ priority = 3, onSeverity }) {
  const { t } = useTranslation()
  const { badgeTitle, severity } = useMemo(() => {
    switch (Number(priority)) {
      case 1:
        return { badgeTitle: t('badges.priority.high', 'HIGH'), severity: 'danger' }
      case 2:
        return { badgeTitle: t('badges.priority.warning', 'WARNING'), severity: 'warning' }
      case 3:
        return { badgeTitle: t('badges.priority.info', 'INFO'), severity: 'info' }
      case 4:
        return { badgeTitle: t('badges.priority.done', 'DONE'), severity: 'success' }
      default:
        return { badgeTitle: t('badges.priority.info', 'INFO'), severity: 'info' }
    }
  }, [priority, t])

  useEffect(() => {
    if (typeof onSeverity === 'function') {
      onSeverity(severity)
    }
  }, [onSeverity, severity])

  return (
    <CBadge color={severity} className="ms-2" size="sm">
      {badgeTitle}
    </CBadge>
  )
}

BadgeComponent.propTypes = {
  priority: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSeverity: PropTypes.func,
}

export default BadgeComponent
